import React from "react";
import { Row, Button } from "reactstrap";
import "./style/BulkRowActionButtonsBar.scss";

export default function BulkRowActionButtonsBar(props) {
	const {
		onApproveSelectedbtnClick,
		disableApproveSelectedbtn,
		disableRejectSelectedbtn,
		onRejectSelectedbtnClick,
		rejectSelectedBtnLoad,
		approveSelectedBtnLoad,
	} = props;

	return (
		<Row>
			<Button
				onClick={onApproveSelectedbtnClick}
				className="actionBarBtn"
				disabled={
					disableApproveSelectedbtn ||
					rejectSelectedBtnLoad ||
					approveSelectedBtnLoad
				}
			>
				{approveSelectedBtnLoad ? (
					<>
						<span
							class="spinner-border spinner-border-sm"
							role="status"
							aria-hidden="true"
						></span>
						<span className="ml-2">Approve</span>
					</>
				) : (
					<span>Approve</span>
				)}
			</Button>
			<Button
				onClick={onRejectSelectedbtnClick}
				className="actionBarBtn actionBarRedBtn"
				disabled={
					disableRejectSelectedbtn ||
					approveSelectedBtnLoad ||
					rejectSelectedBtnLoad
				}
			>
				{rejectSelectedBtnLoad ? (
					<>
						<span
							class="spinner-border spinner-border-sm"
							role="status"
							aria-hidden="true"
						></span>
						<span className="ml-2">Reject</span>
					</>
				) : (
					<span>Reject</span>
				)}
			</Button>
		</Row>
	);
}
